<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><img alt="images" src="images/f015-01.jpg" width="80%"/></p>
<p class="caption">The boundary stream between Maltby and Hooton Levitt acted as a latrine. The King’s Wood, or ‘the wood of Lindrick’ rises beyond.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 19_chapter025.vue?e1270544